<h2>News</h2>
<div class="news">
  <div *ngIf="newsContent && newsContent.length === 0">
    <span>{{noNewsText}}</span>
  </div>
  <div *ngIf="newsContent && newsContent.length > 0">
    <div *ngFor="let news of newsContent" class="news-details-div">
      <div class="align-left">
        <div>
          <h5 class="news-title" (click)="showDialog(news.id)">{{news.title}}</h5>
          <p class="block-with-text" [innerHTML]="news.newsDetails"></p>
        </div>
        <div>
          <span class="bold read-more-link font-mrs-eaves-bold" (click)="showDialog(news.id)">Read more</span> <span
            class="text-red k-icon k-i-arrow-60-right "></span>
        </div>
      </div>
    </div>
  </div>
</div>
<app-notification-loading></app-notification-loading>
